import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.bindEvents();

    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    bindEvents() {
        this.el.addEventListener('click', this.onClick.bind(this));
    }

    unbindEvents() {
        this.el.removeEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
        e.preventDefault();

        const $target = e.currentTarget;
        const id = $target.dataset.videoId;
        const host = $target.dataset.videoHost;

        if (id && host) {
            this.call('openVideo', { id, host }, 'VideoModal');
        }
    }
}
